import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LanguageService } from 'src/app/service/language.service';

// Servicios
import { MessageService } from 'primeng/api';
import { LoginService } from 'src/app/service/login.service';
import { MessagesService } from 'src/app/service/messages.service';
import { UsersService } from 'src/app/service/users.service';

// Interfaces
import { User } from 'src/app/interfaces/user.interface';
import { catchError, throwError, forkJoin } from 'rxjs';

import { TranslateService } from "@ngx-translate/core";
import Swal from 'sweetalert2';

// Expresión regular para validar correos
const correoRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  providers: [MessageService]
})
export class WelcomeComponent implements OnInit {
  private baseApi = environment.baseApi;

  // Modales
  showLogin = true;
  isSignupModalOpen = false;
  showRestore = false;

  // Login
  email: string = '';
  password: string = '';
  showPassword: boolean = false;

  // Register
  registerForm: FormGroup;
  isFormValid: boolean = false; 

  // Restore Password
  loadingApi: boolean = false;

  // Cambio de idioma
  currentLang: any = null; // ¡IMPORTANTE! Así se fuerza el placeholder
    languages = [
    { label: 'Español', value: 'es', icon: 'fas fa-flag' },
    { label: 'English', value: 'en', icon: 'fas fa-flag-usa' }
  ];

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
    private loginService: LoginService,
    private message: MessagesService,
    private userService: UsersService,
    private fb: FormBuilder,
    private http: HttpClient,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {
    this.registerForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern(/^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/)]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', Validators.required],
     
    });

    this.translate.addLangs(['en','es']);

    const saved = this.languageService.getLanguage();      // p.ej. 'en' o 'es'
    this.translate.setDefaultLang(saved);
    this.translate.use(saved);
    this.currentLang = saved;
    
  }

  
  validateInput(event: KeyboardEvent) {
    const char = event.key;
    const pattern = /^[A-Za-zÀ-ÿ\s]$/;
  
    if (!pattern.test(char)) {
      event.preventDefault(); // Bloquea el carácter si no es válido
    }
  }
  // ✅ Mostrar/Ocultar modales
  toggleLogin() {
    this.showLogin = true; 
    this.isSignupModalOpen = false;
    this.showRestore = false;
    this.cdr.detectChanges();
  }

  openSignupModal() {
    this.isSignupModalOpen = true;
    this.showLogin = false;
    this.showRestore = false;
  }

  openShowRestore() {
    this.showRestore = true;
    this.showLogin = false;
    this.isSignupModalOpen = false;
  }
  routeToHome(): void {
    const isPasswordRestored = this.loginService.chatCrmUser.passwordRestore;
    const url = isPasswordRestored ? "/account" : "/dashboard";
    this.router.navigate([url], {
      queryParams: { lang: this.currentLang },
      queryParamsHandling: 'merge'
    });
  }
  private obtenerMensajeTitulo(value: number): string {
    let key: string;
    
    switch (value) {
      case 1: 
        key = 'USER_NOT_FOUND'; 
        break;
      case 2: 
        key = 'PASSWORD_ERROR'; 
        break;
      case 3: 
        key = 'ACCOUNT_ERROR'; 
        break;
      default:
        return '';
    }
    let translatedMessage: string = '';
    this.translate.get(key).subscribe((translation: string) => {
      translatedMessage = translation;
    });
    return translatedMessage;
  }
  quitarEspacios(event: any) {
    this.email = event.value.trim();
    event.value = this.email;
  }
  togglePasswordVisibility(passwordInput: HTMLInputElement): void {
    this.showPassword = !this.showPassword;
    passwordInput.type = this.showPassword ? 'text' : 'password';
  }
  // ✅ Restablecer contraseña
resetPassword() {
  if (!this.email || !correoRegExp.test(this.email)) {
    this.translate.get(this.email ? 'INVALID_EMAIL' : 'EMAIL_REQUIRED').subscribe((msg) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: msg });
    });
    return;
  }

  this.loadingApi = true;
  const userEmail: User = { email: this.email };

  this.userService.restetPassword(userEmail, this.translate.currentLang).pipe(
    catchError((error) => {
      this.loadingApi = false;

      if (error.status === 404) { 
        // 🔹 Traducir el mensaje de aviso y detalle
        this.translate.get(['WARNING', 'EMAIL_NOT_REGISTERED']).subscribe((translations) => {
          this.messageService.add({ 
            severity: 'warn', 
            summary: translations['WARNING'], 
            detail: translations['EMAIL_NOT_REGISTERED'] 
          });
        });
      } else {
        this.translate.get(['ERROR', 'ERROR_RESET_PASSWORD']).subscribe((translations) => {
          this.messageService.add({ 
            severity: 'error', 
            summary: translations['ERROR'], 
            detail: translations['ERROR_RESET_PASSWORD'] 
          });
        });
      }
      

      return throwError(error);
    })
  ).subscribe(() => {
    this.loadingApi = false;
    this.translate.get(['SUCCESS', 'RESTORES_PASS_ALERT_DETAIL']).subscribe((translations) => {
      this.messageService.add({
        severity: 'success',
        summary: translations['SUCCESS'],
        detail: translations['RESTORES_PASS_ALERT_DETAIL']
      });
    });
    
  });
}


// ✅ Iniciar sesión
iniciarSesion() {
  if (!this.email) {
    this.translate.get(['ERROR', 'EMAIL_REQUIRED']).subscribe((translations) => {
      this.messageService.add({
        severity: 'error',
        summary: translations['ERROR'],
        detail: translations['EMAIL_REQUIRED']
      });
    });
    return; 
  }
  if (!correoRegExp.test(this.email)) {
    this.translate.get(['ERROR', 'INVALID_EMAIL']).subscribe((translations) => {
      this.messageService.add({
        severity: 'error',
        summary: translations['ERROR'],
        detail: translations['INVALID_EMAIL']
      });
    });
    return;
  }
  if (!this.password) {
    this.translate.get(['ERROR', 'PASSWORD_REQUIRED']).subscribe((translations) => {
      this.messageService.add({
        severity: 'error',
        summary: translations['ERROR'],
        detail: translations['PASSWORD_REQUIRED']
      });
    });
    return;
  }
  

  const user = { email: this.email, password: this.password };

  this.loginService.userLogin(user)
    .then(() => {
      this.translate.get(['SUCCESS', 'LOGIN_SUCCESS']).subscribe((translations) => {
        console.log('Traducciones cargadas:', translations);
        this.messageService.add({
          severity: 'success',
          summary: translations['SUCCESS'],
          detail: translations['LOGIN_SUCCESS']
        });
        this.routeToHome();
        console.log('');
      });
      

      this.translate.get(['WARNING', 'INACTIVITY_WARNING']).subscribe((translations) => {
        // Mostrar alerta de inactividad
        const swalInstance = Swal.fire({
          icon: 'info',
          title: `<span style="font-size: 14px; font-weight: bold; margin-bottom: 2px; display: block;">${translations['WARNING']}</span>`, 
          html: `<p style="margin: 0; padding-right: 4px; font-size: 14px;">${translations['INACTIVITY_WARNING']}</p>`,
          position: 'top', 
          width: '420px',
          padding: '4px',
          toast: true, 
          showConfirmButton: false,
          showCloseButton: true, 
          timer: 20000,
          background: '#ffffff', 
          iconColor: '#28a745',
          customClass: {
            popup: 'swal-popup',
            icon: 'swal-icon-small'
          },
          willClose: () => {
            this.message.setDispositivo(null);  
          }
        });
        
        // Guardar referencia SOLO de esta alerta - CORRECCIÓN: usar swalInstance
        this.loginService.setInactivityWarningAlert(swalInstance);
      });
           
    })
    .catch(error => {
      console.error("Error en login:", error);
      this.translate.get(['ERROR', 'LOGIN_ERROR']).subscribe((translations) => {
        let errorMessage = translations['LOGIN_ERROR']; // Mensaje de error por defecto
    
        if (error?.error?.message) {
          errorMessage = error.error.message; // Usa el mensaje del backend si existe
        }
    
        this.messageService.add({
          severity: 'error',
          summary: translations['ERROR'],
          detail: errorMessage
        });
      });
    });    
}


ngOnInit() {
  this.loginService.compararTiempoSesion(new Date());

  let nameTimeout: any;
  let emailTimeout: any;
  let passwordTimeout: any;
  let confirmPasswordTimeout: any;

  this.registerForm.get('name')?.valueChanges.subscribe(value => {
    clearTimeout(nameTimeout);
    nameTimeout = setTimeout(() => {
      this.validateName(value);
    }, 10);
  });

  this.registerForm.get('email')?.valueChanges.subscribe(value => {
    clearTimeout(emailTimeout);
    emailTimeout = setTimeout(() => {
      this.validateEmail(value);
    }, 1000);
  });

  this.registerForm.get('password')?.valueChanges.subscribe(value => {
    clearTimeout(passwordTimeout);
    passwordTimeout = setTimeout(() => {
      this.validatePassword(value);
      this.validateConfirmPassword(this.registerForm.get('confirmPassword')?.value); // ✅ Validar confirmación también
    }, 600);
  });

  this.registerForm.get('confirmPassword')?.valueChanges.subscribe(value => {
    clearTimeout(confirmPasswordTimeout);
    confirmPasswordTimeout = setTimeout(() => {
      this.validateConfirmPassword(value);
    }, 600);
  });

  // Verificar la validez del formulario al principio
  this.checkFormValidity();

  // 1. Al iniciar, lee ?lang=… o toma el último guardado
  this.route.queryParams.subscribe(params => {
    const lang = params['lang']
      || this.languageService.getLanguage()
      || 'es';
    this.languageService.setLanguage(lang);
    this.translate.use(lang);
    this.currentLang = lang;
  });
 
  this.translate.onLangChange.subscribe(() => {
    this.cdr.markForCheck();
  });

}


private resetDropdownLanguage() {
  // Fuerza el placeholder después de la renderización inicial
  setTimeout(() => {
    this.currentLang = null;  // null (no 'default') para que PrimeNG muestre el placeholder
    this.cdr.detectChanges();
  });
}

checkFormValidity() {
  this.isFormValid = this.registerForm.valid;
  console.log("¿Formulario válido?:", this.isFormValid); // Verificar si el formulario es válido
  this.cdr.detectChanges(); // Forzar la actualización
}

validateName(value: string) {
  const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
  if (value && !nameRegex.test(value)) {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant('FORM_ERRORS'),
      detail: this.translate.instant('INVALID_NAME_FORMAT'),
      life: 3000
    });
  }
  this.checkFormValidity(); // Verificar la validez después de validar
}

validateEmail(value: string) {
  const correoRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar emails correctamente formateados

  if (!value || value.trim() === '') {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant('FORM_ERRORS'),
      detail: this.translate.instant('EMAIL_REQUIRED'),
      life: 3000
    });
    return;
  }

  if (!correoRegExp.test(value)) {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant('FORM_ERRORS'),
      detail: this.translate.instant('INVALI_EMAIL'),
      life: 3000
    });
    return;
  }

  this.checkFormValidity(); // Verificar la validez después de validar
}


validatePassword(value: string) {
  if (value && value.length < 8) {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant('FORM_ERRORS'),
      detail: this.translate.instant('PASSWORD_MIN_LENGTH'),
      life: 3000
    });
  }
  this.checkFormValidity(); // Verificar la validez después de validar
}

validateConfirmPassword(value: string) {
  const password = this.registerForm.get('password')?.value;

  // 🔹 Si confirmPassword está vacío, mostrar error de campo requerido
  if (!value) {
    this.registerForm.get('confirmPassword')?.setErrors({ required: true });
    this.checkFormValidity();
    return;
  }

  // 🔹 Si hay un password y no coinciden, mostrar error
  if (password && value !== password) {
    this.messageService.add({
      severity: 'warn',
      summary: this.translate.instant('FORM_ERRORS'),
      detail: this.translate.instant('PASSWORD_NOT_MATCH'),
      life: 3000
    });
    this.registerForm.get('confirmPassword')?.setErrors({ passwordMismatch: true });
  } else {
    this.registerForm.get('confirmPassword')?.setErrors(null);
  }
  this.checkFormValidity(); // Verificar la validez después de validar
}

onSubmit() {
  let errors: string[] = [];

  const name = this.registerForm.value.name?.trim();
  const email = this.registerForm.value.email?.trim();
  const password = this.registerForm.value.password;
  const confirmPassword = this.registerForm.value.confirmPassword;

  let validationObservables = [];

  // Verificar si algún campo obligatorio está vacío
  if (!name || !email || !password || !confirmPassword) {
    validationObservables.push(this.translate.get('WARNING_INCOMPLETE_FIELDS'));
  }

  const nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
  if (name && !nameRegex.test(name)) {
    validationObservables.push(this.translate.get('INVALID_NAME_FORMAT'));
  }

  if (password && password.length < 8) {
    validationObservables.push(this.translate.get('PASSWORD_MIN_LENGTH'));
  }

  if (password && confirmPassword && password !== confirmPassword) {
    validationObservables.push(this.translate.get('PASSWORD_NOT_MATCH'));
  }

  // Mostrar los errores uno por uno, con un retraso entre ellos
  if (validationObservables.length > 0) {
    forkJoin(validationObservables).subscribe((messages) => {
      this.translate.get('FORM_ERRORS').subscribe((translatedSummary) => {
        let delay = 0;
        
        messages.forEach((message, index) => {
          setTimeout(() => {
            this.messageService.add({
              severity: 'warn',
              summary: translatedSummary, // Traducción dinámica
              detail: message,
              life: 5000
            });
          }, delay);

          // Incrementar el retraso para la siguiente alerta
          delay += 1500;
        });
      });
    });
    return;
  }

  // Si no hay errores, proceder con el registro
  const customer = { name, email, password };

  this.http.post<any>(`${this.baseApi}/register`, customer).subscribe(
    () => {
      this.translate.get(['REGISTER_SUCCESS', 'SUCCESS_REGISTER']).subscribe(translations => {
        this.messageService.add({
          severity: 'success',
          summary: translations['REGISTER_SUCCESS'],
          detail: translations['SUCCESS_REGISTER'],
          life: 3000
        });
      });

      setTimeout(() => {
        this.showLogin = true;
        this.isSignupModalOpen = false;
      }, 1000);
      setTimeout(() => {
        this.registerForm.reset();
      }, 50000); 
    },
    (error) => {
      if (error.status === 409) {
        this.translate.get(['EMAIL_ALREADY_REGISTERED', 'EMAIL_ALREADY_REGISTERED_DETAIL']).subscribe((translations) => {
          this.messageService.add({
            severity: 'warn',
            summary: translations['EMAIL_ALREADY_REGISTERED'],
            detail: translations['EMAIL_ALREADY_REGISTERED_DETAIL'],
            life: 5000
          });
        });
      } else {
        this.translate.get('REGISTER_ERROR').subscribe((errorMessage) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: errorMessage,
            life: 5000
          });
        });
      }
    }
  );
}

changeLanguage(lang: string): void {
  if (!lang) return;

  // Actualiza URL sin recargar la vista
  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { lang },
    queryParamsHandling: 'merge'
  });

  // Guarda y aplica el idioma
  this.currentLang = lang;
  this.languageService.setLanguage(lang);
  this.translate.use(lang);
}
}

